import $ from "jquery";

export const useModal = (controller, options = {}) => {
    $(controller.element).modal({
        backdrop: 'static',
        focus: false,
        show: false,
    });

    const hasHiddenListener = 'function' === typeof controller.onHide;

    if (hasHiddenListener) {
        controller.disableHiddenListener = false;

        $(controller.element).on('hidden.bs.modal', () => {
            if (controller.disableHiddenListener) {
                return;
            }

            controller.onHide.bind(controller)();
        });
    }

    const controllerDisconnect = controller.disconnect.bind(controller);

    Object.assign(controller, {
        disconnect() {
            $(controller.element).modal('dispose');

            controllerDisconnect();
        },
    });

    if ('undefined' === typeof controller.onOpen) {
        Object.assign(controller, {
            onOpen() {
            },
        });
    }

    controller.open = () => {
        if ('function' === typeof controller.onOpen) {
            if (hasHiddenListener) {
                controller.disableHiddenListener = false;
            }

            controller.onOpen.bind(controller)();
        }

        controller.show();
    };

    controller.close = () => {
        $(controller.element).modal('hide');
    };

    controller.show = () => {
        if (hasHiddenListener) {
            controller.disableHiddenListener = false;
        }

        $(controller.element).modal('show');

        document.activeElement?.blur();
    };

    controller.hide = () => {
        if (hasHiddenListener) {
            controller.disableHiddenListener = true;
        }

        $(controller.element).modal('hide');
    }

    if (options.withGuide) {
        controller.hasShownGuide = false;

        controller.showGuide = (event) => {
            event && event.preventDefault();

            if (controller.hasIconTarget) {
                controller.iconTarget.style.removeProperty('display');
            }

            if (controller.hasGuideTarget) {
                controller.guideTarget.style.removeProperty('display');
            }

            setGuideModalVideo(controller)

            controller.hasShownGuide = true;

            if ('function' === typeof controller.onGuideShown) {
                controller.onGuideShown.bind(controller)();
            }
        };

        controller.hideGuide = (event) => {
            //$(controller.element).children().removeClass('modal-xl')

            event && event.preventDefault();

            if (controller.hasIconTarget) {
                controller.iconTarget.style.setProperty('display', 'none');
            }

            if (controller.hasGuideTarget) {
                controller.guideTarget.style.setProperty('display', 'none');
            }

            if (controller.hasDontShowInputTarget && controller.dontShowInputTarget.checked) {
                controller.setToNotShowAgain();

                setTimeout(() => {
                    controller.iconTarget.remove();
                    if (controller.hasGuideTarget) {
                        controller.guideTarget.remove();
                    }
                }, 0);
            }
        };

        controller.setToNotShowAgain = () => {
            $.post(controller.dontShowAgainUrl, {}, () => {
            }).fail(() => {
            });
        };

        const controllerOnOpen = controller.onOpen.bind(controller);

        Object.assign(controller, {
            onOpen() {
                if (false === controller.hasShownGuide && controller.hasGuideTarget) {
                    controller.showGuide.bind(controller)();

                    return;
                }

                controllerOnOpen();
            },
        });

        const controllerOnHide = controller.onHide.bind(controller);

        Object.assign(controller, {
            onHide() {
                controller.hideGuide();

                controllerOnHide();
            },
        });
    }

    if (options.withViewed) {
        controller.setAsViewed = () => {
            $.post(controller.viewedUrl, {}, () => {
            }).fail(() => {
            });
        }

        const controllerOnOpen = controller.onOpen.bind(controller);

        Object.assign(controller, {
            onOpen() {
                if (false === controller.isViewedValue) {
                    controller.isViewedValue = true;

                    controller.setAsViewed();
                }

                controllerOnOpen();
            },
        });
    }

    if (options.withLitigant) {
        controller.showLitigant = (event) => {
            event && event.preventDefault();

            controller.litigantTarget.style.removeProperty('display');

            if ('function' === typeof controller.onLitigantShown) {
                controller.onLitigantShown();
            }
        };

        controller.hideLitigant = (event) => {
            event && event.preventDefault();

            controller.litigantTarget.style.setProperty('display', 'none');
        };
    }
};


function setGuideModalVideo(controller) {
    if ('unpaid-booking-modal' !== controller.element.id) {
        //$(controller.element).children().addClass('modal-xl')
    }

    if ('direct-payment-modal' === controller.element.id) {
        if ('account_chat_direct_payment' === controller.sourceValue) {
            document.getElementById('direct-payment-video').src = 'https://www.youtube.com/embed/40yCIfUQf70'
        } else {
            document.getElementById('direct-payment-video').src = 'https://www.youtube.com/embed/BeMfzrke0NE'
        }
    } else if ('paid-booking-modal' === controller.element.id) {
        if ('account_sidebar_paid_booking' === controller.sourceValue) {
            document.getElementById('paid-booking-video').src = 'https://www.youtube.com/embed/dWyN1U2jTX8'
        } else {
            document.getElementById('paid-booking-video').src = 'https://www.youtube.com/embed/fMHOgxYirEk'
        }
    }
}